import { render, staticRenderFns } from "./AddDeleteList.vue?vue&type=template&id=b2f78a04&scoped=true&"
import script from "./AddDeleteList.vue?vue&type=script&lang=js&"
export * from "./AddDeleteList.vue?vue&type=script&lang=js&"
import style0 from "./AddDeleteList.vue?vue&type=style&index=0&id=b2f78a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f78a04",
  null
  
)

export default component.exports